<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="城市编码/名称/首字母"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="城市编码">
          <el-input
            v-model="listQuery.city_code"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="城市名称">
          <el-input
            v-model="listQuery.city_name"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="城市首字母">
          <el-input
            v-model="listQuery.words"
            placeholder="精确查询"
            clearable
            style="width: 120px"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <li-cheng-sync-button
            resource="city"
            label="同步城市"
            @synced="getList"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="分组ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.group_id }}
        </template>
      </el-table-column>

      <el-table-column label="城市编码" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.city_code }}
        </template>
      </el-table-column>

      <el-table-column label="城市名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.city_name }}
        </template>
      </el-table-column>

      <el-table-column label="城市首字母" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.words }}
        </template>
      </el-table-column>

      <el-table-column label="原始JSON" min-width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.raw_json">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewJson(scope.row)"
          >
            查看原始JSON
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看原始JSON弹窗 -->
    <el-dialog
      title="原始JSON数据"
      :visible.sync="dialogJsonVisible"
      width="800px"
      :close-on-click-modal="true"
    >
      <div v-if="currentJson" class="json-content">
        <pre>{{ currentJson }}</pre>
      </div>
      <div v-else class="json-empty">
        <span>无原始数据</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogJsonVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        city_code: undefined,
        city_name: undefined,
        words: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看JSON弹窗
      dialogJsonVisible: false,
      currentJson: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/cityList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        city_code: undefined,
        city_name: undefined,
        words: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看原始JSON
    handleViewJson(row) {
      if (row.raw_json) {
        try {
          // 尝试格式化JSON
          const parsed = JSON.parse(row.raw_json)
          this.currentJson = JSON.stringify(parsed, null, 2)
        } catch (e) {
          // 如果解析失败，直接显示原始字符串
          this.currentJson = row.raw_json
        }
      } else {
        this.currentJson = ''
      }
      this.dialogJsonVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.json-content {
  max-height: 500px;
  overflow: auto;
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 12px;
    line-height: 1.5;
    color: #333;
  }
}
.json-empty {
  text-align: center;
  padding: 40px;
  color: #999;
}
</style>
